import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNiacinamideGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.454 10.026 17.097 10l-.203.295-8.69 12.644-.204.297.155.325 6.592 13.848.155.326.36.028 15.282 1.204.36.029.204-.298 8.69-12.643.203-.296-.154-.325-6.592-13.948-.156-.33-.364-.026-15.28-1.104ZM9.44 23.349l8.282-12.05 14.56 1.051 6.282 13.293-8.28 12.05-14.562-1.148L9.439 23.35Zm14.533-8.335 1.24.093-.465 6.283-1.238-.092-2.305-3.99-.212-.43-.31 4.209-1.23-.092.463-6.283 1.221.091 2.295 3.998.229.45.312-4.237Zm6.852 9.632.157.445 1.1 3.111.147.418-.346.277-2.497 2.007-.358.288-.381-.256-2.697-1.806-.379-.254.127-.439.899-3.11.122-.423.439-.027 3.196-.201.471-.03Zm-3.15 1.45-.65 2.25 1.936 1.296 1.794-1.441-.794-2.248-2.286.143Zm-6.984 3.701-.161-.432-.461.027-1.698.1-.431.026-.129.412-.5 1.606-.133.43.366.263 1.398 1.004.383.274.37-.291 1.397-1.104.358-.283-.16-.426-.599-1.606Zm-2.052 1.68.237-.762.806-.048.278.746-.671.53-.65-.466Z",
    fill: "currentColor"
  }));
}

export { SvgNiacinamideGlyph as default };
